require('./brokerETFsView.scss');
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter, Prompt } = require('react-router-dom');

// @commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');

// @components
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const BrokerMyInvestmentsProducts = require('components/broker/myInvestments/brokerMyInvestmentsProducts/brokerMyInvestmentsProducts');
const BrokerMyInvestmentsContracts = require('components/broker/myInvestments/brokerMyInvestmentsContracts/brokerMyInvestmentsContracts');
const { BrokerCustomProductLoader } = require('components/broker/brokerCustomProductLoader/brokerCustomProductLoader');
const {
    BrokerInvestmentSpecialist
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const BrokerInformationAboutProduct = require('components/broker/brokerInformationAboutProduct/brokerInformationAboutProduct');
const { BrokerClientWarningModal } = require('components/broker/commons/brokerClientWarningModal/brokerClientWarningModal');
const { BrokerSearchWidget } = require('components/broker/brokerSearchWidget/brokerSearchWidget');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerRiskIndicator = require('components/broker/brokerRiskIndicator/brokerRiskIndicator');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKLink } = require('commonsComponents/OKLink');


// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @actions
const BrokerStocksByTypeActions = require('actions/brokerStocksByType');
const BrokerStocksByContractActions = require('actions/brokerWallets');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerOrdersAndMovementsActions = require('actions/brokerOrdersAndMovements');
const BrokerClientWarningModalAction = require('actions/brokerClientWarningModal');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');
const BrokerSearchWidgetActions = require('actions/brokerSearchWidget');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');
const BrokerContractStateAction = require('actions/brokerContractState');

// @utilites
const {
    PROC_BROKER_ETFS_PG_NAME,
} = require('utilities/tagging');

// @constants
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { MYPROFILE_BROKER_EXPLORE_ETFS_URL,
    MYPROFILE_BROKER_URL,
    MYPROFILE_BROKER_ERROR_URL,
    TYPE_ETFS,
    COLLECTIVE_ETF_COMMISSION,
} = require('constants/index');

class BrokerETFsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            nextLocation: null,
            isBlockingRouteChange: false,
        };

        this.handleBuyClick = this.handleBuyClick.bind(this);
        this.buildETFsTabbedContent = this.buildETFsTabbedContent.bind(this);
        this.handleETFsBuySellClick = this.handleETFsBuySellClick.bind(this);
        this.breadcrumb = [
            {
                text: formatText('etfs-investments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('etfs-etfs'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        const { history, immProfile, immBrokerMyInvestments } = this.props;

        this.props.getStocksByType();
        this.props.getStocksContracts();
        this.props.checkPersonalInformationData();

        if (immProfile.get('isCollective')) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVE_ETF_COMMISSION, history);
        }
        if (immBrokerMyInvestments.get('fetchSuccess')) {
            this.setPageInteraction();
        }
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const { immBrokerMyInvestments } = this.props;
        const immBrokerMyInvestmentsPrev = prevProps.immBrokerMyInvestments;

        if (
            immBrokerMyInvestments.get('fetchSuccess') &&
            !immBrokerMyInvestmentsPrev.get('fetchSuccess')
        ) {
            this.setPageInteraction();
        }
    }

    setPageInteraction() {
        const { immBrokerMyInvestments } = this.props;
        const productStatus = immBrokerMyInvestments.getIn(['products', 'etfs', 'total']) > 0
            ? 'active'
            : 'empty';

        this.setState({
            setProductStatus: true,
        })
        taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'productStatusActive', productStatus);
    }

    buildCallMeBackContent() {
        return <BrokerInvestmentSpecialist />;
    }

    getTabContent() {
        const {
            immBrokerWallets,
            immMyWalletCharts,
            getStocksByContract,
            postWalletAlias,
            onOpenTraderClick,
            setOrdersAndMovementsAccessFrom,
            setOrdersAndMovementsContract,
            immBrokerMyInvestments,
            immBrokerLandingLoader,
            immAccounts,
            getContractState
        } = this.props;

        const activeTab = immBrokerLandingLoader.get('activeTab');
        const isFetchingStocksByContract = immBrokerWallets.get('isFetchingProducts');
        const immStocksByContract = immBrokerWallets.get('walletList');
        const immStocksContracts = immBrokerMyInvestments.get('contracts');

        const immStocksByType = immBrokerMyInvestments.get('products');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');

        if (activeTab == 0) {
            return (<BrokerMyInvestmentsProducts
                immStocksByType={immStocksByType}
                isFetchingStocksByType={isFetchingStocksByType}
                setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                displayAlternativeFunds={false}
                displayStocks={false}
                displayWarrants={false}
                displayETFs={true}
                displayFunds={false}
                displayCrypto={false}
                displayPlans={false}
                displayOthers={false}
                startExpanded={true}
                alternativeValueColumnTitle={true}
                displayFooter={false}
                onOpenTraderClick={onOpenTraderClick}
                onHandleBuyClick={this.handleETFsBuySellClick}
                resetSpecificProduct={this.props.resetSpecificProduct}
                pageName={PROC_BROKER_ETFS_PG_NAME}
            />);
        }

        return (<BrokerMyInvestmentsContracts
            immAccounts={immAccounts}
            getStocksByContract={getStocksByContract}
            immStocksByContract={immStocksByContract}
            immStocksContracts={immStocksContracts}
            immStocksByType={immStocksByType}
            immMyWalletCharts={immMyWalletCharts}
            isFetchingStocksByContract={isFetchingStocksByContract}
            postWalletAlias={postWalletAlias}
            setOrdersAndMovementsContract={setOrdersAndMovementsContract}
            onOpenTraderClick={onOpenTraderClick}
            displayStocks={true}
            displayPlans={false}
            displayFunds={false}
            displayFooter={false}
            displayCrypto={false}
            onHandleBuyClick={this.handleETFsBuySellClick}
            getContractState={getContractState}
            pageName={PROC_BROKER_ETFS_PG_NAME}
        />);
    }

    buildETFsTabbedContent() {
        const {
            immBrokerMyInvestments,
        } = this.props;

        const immStocksByType = immBrokerMyInvestments.get('products');
        const etfs = immStocksByType.get('etfs');
        const emptyStocks = !etfs || etfs.get('stocks').size === 0;
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const title = formatText('etfs-myPositions');
        const tab = this.getTabContent();

        if (!isFetchingStocksByType && emptyStocks) {
            return undefined;
        }

        return (
            <ContentBox
                id={"brokerETFs"}
                title={title}
                customClassName={"tabbed-content-box broker-my-investments"}
            >
                {tab}
            </ContentBox>
        );
    }

    buildProductInfoContent() {
        const { immBrokerMyInvestments, immGlobalVariables } = this.props;
        const immStocksByType = immBrokerMyInvestments.get('products');
        const etfs = immStocksByType.get('etfs');
        const emptyStocks = !etfs || etfs.get('stocks').size === 0;

        return (
            <BrokerInformationAboutProduct
                productType={TYPE_ETFS}
                onBuyClick={() => this.handleBuyClick('comercialCard')}
                immProfile={this.props.immProfile}
                immCollectivesCommissions={this.props.immCollectivesCommissions}
                hasButton={!emptyStocks}
                immGlobalVariables={immGlobalVariables}
                pageName={PROC_BROKER_ETFS_PG_NAME}
            />
        );
    }

    handleBuyClick(component) {
        taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, component === 'comercialCard' ? 'buyButtonComCard' : 'buyButton');
        this.props.resetSpecificProduct(TYPE_ETFS.toUpperCase());
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_ETFS_URL);
    }

    handleETFsBuySellClick(nextLink) {
        const { immbrokerClientWarningModal, showClientWarningModal, history } = this.props;
        const clientPersonalInfoUpdated = immbrokerClientWarningModal.get('clientPersonalInfoUpdated');
        const isFetching = immbrokerClientWarningModal.get('isFetching');
        const isFetched = immbrokerClientWarningModal.get('isFetched');

        if (isFetched && !isFetching) {
            if (!clientPersonalInfoUpdated) {
                showClientWarningModal(history);
                this.setState({
                    nextLocation: nextLink,
                    isBlockingRouteChange: true
                });
            } else {
                history.push(nextLink);
            }
        } else if (!isFetched && !isFetching) {
            history.push(MYPROFILE_BROKER_ERROR_URL);
        }
        window.modalInstance = this;
    }

    render() {
        const { immBrokerMyInvestments } = this.props;
        const productInfoContent = this.buildProductInfoContent();
        const callMeBackContent = this.buildCallMeBackContent();
        const ETFsTabbedContent = this.buildETFsTabbedContent();
        let ETFsTabbedContentObject = null;
        let ETFsCTAsObject = null;
        const buySellBtnText = formatText('broker-buySellBtnText');
        const searchButtonText = formatText('brokerSearchWidget-brokerSearchWidget_searchETFs');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const links = [getPublicSiteUrl()];
        const linksOfComponent = links.length && links.map((link) => {
            const linkName = link.replace(/(^\w+:|^)\/\//, '');
            return (<OKLink key={link} to={link} target="_blank">{linkName}</OKLink>);
        });
        let actionLinkButton = (
            <div className="broker-general-view__action-link-btn col-sm-4">
                <OKButton
                    modifier="primary"
                    onClick={this.handleBuyClick}
                >
                    {buySellBtnText}
                </OKButton>
            </div>
        );

        const searchButton = (
            <div className="broker-general-view__action-link-btn col-sm-8">
                <OKButton
                    modifier="secondary"
                    leftIcon="icon-s-buscar"
                    block={true}
                    onClick={() => {
                        taggingEventHandled(PROC_BROKER_ETFS_PG_NAME, 'searchButton')
                        this.props.handleShowSearchWidget()
                    }}
                >
                    {searchButtonText}
                </OKButton>
            </div>
        );

        if (!isFetchingStocksByType) {
            if (ETFsTabbedContent) {
                ETFsTabbedContentObject = (
                    <div className="row">
                        <div className="col-xs-12 col-md-8 broker-general-view__custom-product-loader">
                            <BrokerCustomProductLoader pageName={PROC_BROKER_ETFS_PG_NAME} />
                        </div>
                        <div className="col-xs-12 col-md-4 broker-general-view__general-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                        <div className="col-md-12 grid-view--fix-cell-separation">
                            {ETFsTabbedContent}
                        </div>
                    </div>
                );
            } else {
                ETFsCTAsObject = (
                    <div className="row">
                        <div className="col-md-12 broker-general-view__landing-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                    </div>
                );
            }
        }
        else {
            ETFsTabbedContentObject = <LoadingSection />
        }
        return (
            <React.Fragment>
                <Prompt message={() => false} when={this.state.isBlockingRouteChange} />
                <div>
                    <div className="broker-general-view__search-widget">
                        <BrokerSearchWidget product={TYPE_ETFS} />
                    </div>
                    <BrokerClientWarningModal
                        nextLocation={this.state.nextLocation}
                        routerHookCallback={() => {
                            this.setState({ isBlockingRouteChange: false });
                        }}
                    />
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="higher-small" section="broker" customClass="col-xs-12">
                                <BrokerTruncatedBreadcrumb
                                    titleKey="etfs-title"
                                    breadcrumbConfig={this.breadcrumb}
                                />
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid grid-view--content-position-positive">
                            <div className="broker-funds-view__broker-risk-indicator">
                                <BrokerRiskIndicator
                                    riskValue={0}
                                    textContent="broker-stocksLikeHeaderRiskContent"
                                    productType="Etfs"
                                />
                            </div>
                            {ETFsTabbedContentObject}
                            <div className="row">
                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className={`col-md-12 ${ETFsTabbedContent ? 'grid-view--fix-cell-separation' : ''}`}>
                                            {productInfoContent}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    {ETFsCTAsObject}
                                    <div className="row">
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {callMeBackContent}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 grid-view__sources">
                                    <FormattedText value="broker-infoETFsSource" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 grid-view__sources" >
                                    <FormattedTextWithComponents className="broker-etfs-view__source-text" value="broker-infoETFsSource_second" injectedComponents={linksOfComponent} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid grid-view__cross-selling">
                        <div className="row">
                            <CommercialAds path="broker/general" type="cross-selling" />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

BrokerETFsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getStocksByContract: PropTypes.func.isRequired,
    postWalletAlias: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    immbrokerClientWarningModal: PropTypes.object,
    showClientWarningModal: PropTypes.func,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    immProfile: PropTypes.object,
    checkPersonalInformationData: PropTypes.func,
    getCollectivesCommissionsInfo: PropTypes.func,
    immCollectivesCommissions: PropTypes.object.isRequired,
    immMyWalletCharts: PropTypes.object.isRequired,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    handleShowSearchWidget: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func,
    getContractState: PropTypes.func.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
};


module.exports.constructor = BrokerETFsView;
module.exports.BrokerETFsView = connect(
    state => ({
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerWallets: state.brokerWallets,
        immbrokerClientWarningModal: state.brokerClientWarningModal,
        immMyWalletCharts: state.myWalletCharts,
        immProfile: state.profile,
        immCollectivesCommissions: state.collectivesCommissions,
        immBrokerLandingLoader: state.brokerLandingLoader,
        immAccounts: state.accounts,
        immGlobalVariables: state.globalVariables,
    }),
    {
        getStocksByType: BrokerStocksByTypeActions.getStocksByType,
        getStocksContracts: BrokerStocksByContractActions.getWalletList,
        getStocksByContract: BrokerStocksByContractActions.getStocksByWallet,
        postWalletAlias: BrokerStocksByContractActions.postWalletAlias,
        onOpenTraderClick: BrokerOpenTraderActions.openLink,
        setOrdersAndMovementsAccessFrom: BrokerOrdersAndMovementsActions.setAccessFrom,
        setOrdersAndMovementsContract: BrokerOrdersAndMovementsActions.setContractNumber,
        showClientWarningModal: BrokerClientWarningModalAction.showClientWarningModal,
        checkPersonalInformationData: BrokerClientWarningModalAction.checkPersonalInformationData,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo,
        handleShowSearchWidget: BrokerSearchWidgetActions.showSearchWidget,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct,
        getContractState: BrokerContractStateAction.getContractState
    }
)(withRouter(BrokerETFsView));
